import _ from 'lodash';
import history from 'common/history';
import { csrfFromDom } from 'common/utils/server';
import api from '../api';

const NEXT_STEP = 'calibrationWizard/NEXT_STEP';
const TOGGLE_QUESTION = 'calibrationWizard/TOGGLE_QUESTION';
const DELSELECT_ALL = 'calibrationWizard/DELSELECT_ALL';
const SELECT_ALL = 'calibrationWizard/SELECT_ALL';
const SELECT_PARTICIPANT = 'calibrationWizard/SELECT_PARTICIPANT';
const REMOVE_PARTICIPANT = 'calibrationWizard/REMOVE_PARTICIPANT';
const UPDATE_PARTICIPANT_INPUT = 'calibrationWizard/UPDATE_PARTICIPANT_INPUT';
const UPDATE_MEETING_DATE = 'calibrationWizard/UPDATE_MEETING_DATE';
const CREATE_CALIBRATION_SUCCESS =
  'calibrationWizard/CREATE_CALIBRATION_SUCCESS';
const FETCH_QUESTIONS_SUCCESS = 'calibrationWizard/FETCH_QUESTIONS_SUCCESS';
const UPDATE_LOADING = 'calibrationWizard/UPDATE_LOADING';
const UPDATE_TOTAL_STEPS = 'calibrationWizard/UPDATE_TOTAL_STEPS';

// Action Creators

export const nextStep = () => ({
  type: NEXT_STEP,
});

export const toggleQuestion = id => ({
  type: TOGGLE_QUESTION,
  id,
});

export const selectAll = questions => ({
  type: SELECT_ALL,
  questions,
});

export const deselectAll = () => ({
  type: DELSELECT_ALL,
});

export const selectParticipant = participant => ({
  type: SELECT_PARTICIPANT,
  participant,
});

export const updateParticipantInput = participantInput => ({
  type: UPDATE_PARTICIPANT_INPUT,
  participantInput,
});

export const removeParticipant = participant => ({
  type: REMOVE_PARTICIPANT,
  participant,
});

export const updateMeetingDate = date => ({
  type: UPDATE_MEETING_DATE,
  date,
});

const createCalibrationSuccess = () => ({
  type: CREATE_CALIBRATION_SUCCESS,
});

export const fetchQuestionsSuccess = questions => ({
  type: FETCH_QUESTIONS_SUCCESS,
  questions,
});

const updateLoading = bool => ({
  type: UPDATE_LOADING,
  bool,
});

export const updateTotalSteps = totalSteps => ({
  type: UPDATE_TOTAL_STEPS,
  totalSteps,
});

// Thunks

export const fetchQuestions = formId => dispatch => {
  dispatch(updateLoading(true));
  return api
    .fetch(dispatch, `qa_questions?form_id=${formId}`)
    .then(([json]) => {
      dispatch(fetchQuestionsSuccess(json.qa_questions));
      dispatch(updateLoading(false));
    });
};

export const createCalibration = () => (dispatch, getState) => {
  const {
    participants,
    questionIds,
    meetingDate,
  } = getState().qaCalibrationWizard;
  const {
    form,
    solicitationId,
    interactionId,
    interactionLink,
    employee,
    transcript,
    keyName,
    interaction,
  } = getState().qaReview;

  return api
    .fetch(dispatch, 'qa_calibrations', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-token': csrfFromDom(),
      },
      body: JSON.stringify({
        participant_ids: _.map(participants, 'id'),
        qa_question_ids: questionIds,
        meeting_at: meetingDate,

        qa_form_id: form.id,
        employee_id: employee.id,
        solicitation_id: solicitationId,
        interaction_id: interactionId,
        interaction_url: interactionLink,
        filename: keyName,
        transcript,
        interaction,
      }),
    })
    .then(([json]) => {
      dispatch(createCalibrationSuccess());
      history.replace(`/qa/reviews/${json.current_user_qa_review.id}`);
      return Promise.resolve();
    });
};

// Reducer

const initialState = {
  step: 1,
  totalSteps: 3,
  questionIds: [],
  participants: [],
  participantInput: '',
  meetingDate: null,
  questions: [],
  loading: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_QUESTIONS_SUCCESS: {
      return { ...state, questions: action.questions };
    }
    case NEXT_STEP: {
      return {
        ...state,
        step: state.step + 1,
      };
    }
    case SELECT_ALL: {
      return {
        ...state,
        questionIds: _.map(action.questions, 'id'),
      };
    }
    case DELSELECT_ALL: {
      return {
        ...state,
        questionIds: [],
      };
    }
    case TOGGLE_QUESTION: {
      const found = _.find(state.questionIds, el => el === action.id);
      const questionIds = found
        ? _.filter(state.questionIds, el => el !== action.id)
        : _.concat(state.questionIds, [action.id]);
      return {
        ...state,
        questionIds,
      };
    }
    case UPDATE_PARTICIPANT_INPUT: {
      const { participantInput } = action;
      return {
        ...state,
        participantInput,
      };
    }
    case SELECT_PARTICIPANT: {
      const found = _.find(
        state.participants,
        el => el.id === action.participant.id
      );
      if (found) {
        return {
          ...state,
          participantInput: '',
        };
      }
      return {
        ...state,
        participantInput: '',
        participants: _.concat(state.participants, [action.participant]),
      };
    }
    case REMOVE_PARTICIPANT: {
      return {
        ...state,
        participants: _.filter(
          state.participants,
          el => el.id !== action.participant.id
        ),
      };
    }
    case UPDATE_MEETING_DATE: {
      return {
        ...state,
        meetingDate: action.date,
      };
    }
    case UPDATE_TOTAL_STEPS: {
      return {
        ...state,
        totalSteps: action.totalSteps,
      };
    }
    case CREATE_CALIBRATION_SUCCESS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
